module.exports = __webpack_public_path__ + "img/icono_cotizacion.a8ef8d93.svg";